import React, { Component } from "react";
import Select from "react-select";
import { Button, Form, Icon } from "tabler-react";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import * as conf from "../../config/config";

const HARDWARE_OPTIONS = [
  { value: 231, label: "TIVE" },
  { value: 726, label: "TIVE SkyBlue" },
];

class GPSTiveForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imei: "",
      hardware: null,
      verificando: false,
      guardando: false,
      dispositivo: null,   // {deviceId, deviceName} si fue encontrado
      mensajeError: null,
      mensajeOk: null,
    };
  }

  verificar = () => {
    const imei = this.state.imei.trim().replace(/\s+/g, "");
    if (!imei) return;

    this.setState({ verificando: true, dispositivo: null, mensajeError: null, mensajeOk: null });

    const token = sessionStorage.getItem("tok");
    fetch(conf.api_raiz + "gps/tive/verificar?imei=" + encodeURIComponent(imei), {
      headers: { Authorization: "Bearer " + token },
    })
      .then((r) => r.json())
      .then((data) => {
        if (!data.existe_tive) {
          this.setState({ verificando: false, mensajeError: "El IMEI no existe en Tive." });
        } else if (data.existe_db) {
          this.setState({ verificando: false, mensajeError: "El IMEI ya está registrado en SkyOne." });
        } else {
          this.setState({
            verificando: false,
            dispositivo: { deviceId: data.deviceId, deviceName: data.deviceName },
            mensajeOk: "Dispositivo encontrado: " + (data.deviceName || data.deviceId),
          });
        }
      })
      .catch(() => this.setState({ verificando: false, mensajeError: "Error al consultar Tive." }));
  };

  guardar = () => {
    const { dispositivo, hardware } = this.state;
    if (!dispositivo || !hardware) return;

    this.setState({ guardando: true });

    const gps = {
      nombre: dispositivo.deviceName || dispositivo.deviceId,
      imei: dispositivo.deviceId,
      idProvedor: 36,
      gpsEstatus: { id: 1 },
      gpsHardware: { id: hardware.value },
      estatus: 1,
      altaFecha: null,
    };

    Crud_Catalogos("gps", "gpsTive", "post", "", gps, "", "", "", [])
      .then(() => {
        this.setState({ guardando: false });
        if (this.props.cerrarModal) this.props.cerrarModal();
      })
      .catch(() => this.setState({ guardando: false, mensajeError: "Error al guardar el GPS." }));
  };

  render() {
    const { imei, hardware, verificando, guardando, dispositivo, mensajeError, mensajeOk } = this.state;
    const puedeGuardar = dispositivo && hardware && !guardando;

    return (
      <div>
        {mensajeError && <div className="alert alert-danger">{mensajeError}</div>}
        {mensajeOk    && <div className="alert alert-success">{mensajeOk}</div>}

        <Form.Group label="IMEI del dispositivo Tive">
          <div className="input-group">
            <Form.Input
              name="imei"
              type="text"
              placeholder="Ej: 869267072215572"
              value={imei}
              onChange={(e) => this.setState({
                imei: e.target.value,
                dispositivo: null,
                mensajeError: null,
                mensajeOk: null,
              })}
            />
            <div className="input-group-append">
              <Button
                color="secondary"
                disabled={!imei.trim() || verificando}
                onClick={this.verificar}
              >
                {verificando ? "Verificando..." : "Verificar"}
              </Button>
            </div>
          </div>
        </Form.Group>

        <Form.Group label="Hardware">
          <Select
            placeholder="Selecciona el tipo"
            options={HARDWARE_OPTIONS}
            value={hardware}
            onChange={(v) => this.setState({ hardware: v })}
            isDisabled={!dispositivo}
          />
        </Form.Group>

        <div className="float-right">
          <Button
            size="sm"
            color="primary"
            disabled={!puedeGuardar}
            onClick={this.guardar}
          >
            <Icon link={true} name="save" />
            {guardando ? " Guardando..." : " Guardar"}
          </Button>
        </div>
      </div>
    );
  }
}

export default GPSTiveForm;
